import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { ProfileType } from '../../../models/profiletype.model';
import { DialogService } from '../../../services/dialogservice';
import { MarketService } from '../../../services/marketservice';
import { NotificationService } from '../../../services/notificationservice';

@Component({
  selector: 'app-addedit-market',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
  templateUrl: './addedit-market.component.html',
  styleUrl: './addedit-market.component.scss',
})
export class AddeditMarketComponent {
  profile: ProfileType | undefined;
  marketForm!: FormGroup;
  isEditMode: boolean = false;
  @Input() marketData: any; // Simple string input
  @Output('onFormSubmit') formEmitter = new EventEmitter<any>();
  data = {
    id: '',
    regionName: '',
  };
  isPageLoad = false;
  userRole = '';
  canSave: boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddeditMarketComponent>,
    private _dialog: MatDialog,
    private marketService: MarketService,
    private dialogService: DialogService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    //this.getRoles()
    this.canSave = this.marketData.canSave;
    if (this.marketData?.formData) {
      this.data = this.marketData?.formData;
      this.isEditMode = !this.marketData?.isAddForm;
    }
    this.marketForm = this.fb.group({
      regionName: [this.data?.regionName || '', Validators.required],
    });
  }

  onSubmit(): void {
    if (this.marketForm.valid) {
      const formData = this.marketForm.value;
      formData['ID'] = this.data?.id || 0;
      formData['regionName'] = this.marketForm?.value?.regionName || '';
      if (this.isEditMode) {
        this.marketService.createMarket(formData).subscribe({
          next: (response: any) => {
            //this.dialogRef.close(true);
            this.formEmitter.emit({ submit: true });
            this.notificationService.show(
              'Market updated successfully',
              'success'
            );
          },
          // error: (err: any) => {
          //   console.error('Error creating market:', err);
          // }
        });
      } else {
        this.marketService.createMarket(formData).subscribe({
          next: (response: any) => {
            //this.dialogRef.close(true);
            this.formEmitter.emit({ submit: true });
            this.notificationService.show(
              'Market created successfully',
              'success'
            );
          },
          // error: (err: any) => {
          //   console.error('Error creating market:', err);
          // }
        });
      }
    }
  }

  onCancel(): void {
    this.formEmitter.emit({ submit: false });
  }

  getProfile() {
    // this.execService.getProfile().subscribe(profile => {
    //   this.profile = profile;
    // });
  }

  getRoles() {
    // this.fsService.getUserRoles().subscribe({
    //   next: (response: any) => {
    //     this.isPageLoad = true;
    //     this.userRole = response?.role;
    //     // this.dialogRef.close(true);
    //     //this.formEmitter.emit({submit:true})
    //   },
    //   error: (err: any) => {
    //     console.error('Error creating acronym:', err);
    //     this.isPageLoad = true;
    //   }
    // });
  }

  buildForm() {
    console.log(this.profile);
    if (this.marketData?.formData) {
      this.data = this.marketData?.formData;
      this.isEditMode = !this.marketData?.isAddForm;
    }

    this.marketForm = this.fb.group({
      market: [this.data?.regionName || '', Validators.required],
    });
  }
}
